export const SET_PAGE_QUALIFIER_TYPE = function(pageQualifierType) {
    return (dispatch) => {
        dispatch({
            type: "SET_PAGE_QUALIFIER_TYPE",
            pageQualifierType
        });
    };
};
